import {
  GetLongTextDocument,
  GetLongTextQuery,
  GetLongTextQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';

import { getLocalesForGraphQL } from '../utils/helpers';

export async function getLongText(id: string, locale: string) {
  return client.query<GetLongTextQuery, GetLongTextQueryVariables>({
    query: GetLongTextDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
